import React from 'react';
import { Button, makeStyles } from '@material-ui/core';

const BackButton = (props) => {
    const { width, ...other } = props;
    const classes = useStyles(props);

    return (
        <Button
            width={props.width}
            position={props.position}
            className={classes.button}
            onClick={props.clickHandler}
            transform={props.transform}
        ><img src={require('../../../style/img/path_1111.png')} alt={"뒤로가기"}/></Button>
    );
};

const useStyles = makeStyles({
    button: {
        width: '47.1px',

        position: (props) =>
            props.position &&
                'fixed',
        backgroundColor: '#e9e9e9',
        border: '2px solid #a5a5a5',
        borderRadius: '23.7px',
        boxShadow: '0px 5px 4px 0px rgba(0,0,0,0.2)',
        height: '47.3px',
        marginTop: '5px',
        minWidth: '0',
        padding: '0 16px',
        
        bottom: (props) =>
            props.transform &&
                '20px',
        left: (props) =>
            props.transform &&
                '8%',
        '@media (min-width: 600px)': {
                    left: (props) =>
                    props.transform &&
                        '12% !important',
                },
        transform: (props) =>
            props.transform &&
                'translateX(-50%)',
        '& span': {
            fontSize: '15px',
            color: '#262626',
            fontWeight: '800',
            fontFamily: 'inherit',
        },
        zIndex: '30',
    },
});

export default BackButton;
